var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAm2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 377.95334,
    height: 377.95334,
    viewBox: "0 0 377.95334 377.95334",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-86.760902,-76.184299)",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-104.7258,-93.6257)",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-123.0168,-96.110105)",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-144.549,-99.732102)",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-174.3508,-76.533904)",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    id: "path14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-199.3888,-76.184299)",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-217.35561,-93.6257)",
    id: "path18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-60.564602,-67.903999)",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-82.815602,-65.401099)",
    id: "path22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-120.22671,-48.182299)",
    id: "path24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-134.64861,-65.401099)",
    id: "path26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-152.89761,-67.903999)",
    id: "path28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-168.99921,-48.182299)",
    id: "path30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-198.60861,-67.784899)",
    id: "path34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,283.465 H 283.465 V 0 H 0 Z",
    transform: "translate(-218.35861,-65.401099)",
    id: "path36"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 0,0 7.782,-18.735 2.074,-4.626 4.127,-9.912 H -13.87 Z m 19.305,57.771 h -2.778 l -16.47,-39.15 -16.471,39.15 h -2.777 L -70.049,-63.121 h 8.033 l 16.555,39.762 27.656,66.221 13.941,-33.56 -30.467,-72.423 h 8.034 l 9.561,22.964 H 16.85 l 9.56,-22.964 h 8.036 L 3.932,9.407 l 13.982,33.456 25.6,-61.627 2.061,-4.597 16.554,-39.76 h 8.035 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,188.1044,141.77533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 0,0 -3.944,-9.203 h 7.888 z m 7.334,-17.092 -2.541,5.933 h -9.584 l -2.542,-5.933 h -2.425 l 9.612,21.797 h 0.38 l 9.613,-21.797 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,85.993733,253.11907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 0,0 c -6.605,0 -11.366,4.616 -11.366,11.043 0,6.312 4.879,11.073 11.366,11.073 2.833,0 5.375,-0.992 7.069,-2.044 L 6.105,18.085 c -1.811,1.053 -4.265,1.841 -6.311,1.841 -5.404,0 -8.619,-3.827 -8.619,-8.883 0,-5.054 3.419,-8.853 8.825,-8.853 2.044,0 4.498,0.789 6.311,1.841 L 7.069,2.044 C 5.375,0.992 2.833,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,115.6812,276.37427)",
    clipPath: "url(#clipPath4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 0,0 -3.944,-9.203 h 7.888 z m 7.334,-17.092 -2.541,5.933 h -9.584 l -2.543,-5.933 h -2.424 l 9.612,21.797 h 0.38 l 9.613,-21.797 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,139.6344,253.11907)",
    clipPath: "url(#clipPath6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 0,0 c -1.285,0 -2.688,-0.088 -3.447,-0.233 v -17.269 c 0.904,-0.174 2.046,-0.233 3.739,-0.233 6.311,0 9.204,3.973 9.204,9.056 C 9.496,-3.711 6.225,0 0,0 m 0,-19.752 c -2.162,0 -4.12,0.176 -5.786,0.353 V 1.636 c 1.638,0.205 3.42,0.35 5.582,0.35 8.034,0 12.242,-5.171 12.242,-10.665 0,-5.756 -4.004,-11.073 -12.038,-11.073",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,164.0224,249.80653)",
    clipPath: "url(#clipPath8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M 0,0 -0.673,1.287 4.44,4.939 5.58,2.601 Z M -5.377,-23.198 V -1.781 H 7.158 V -3.886 H -3.039 v -7.391 h 9.174 v -2.103 h -9.174 v -7.714 H 7.158 v -2.104 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,192.732,244.9772)",
    clipPath: "url(#clipPath10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M 0,0 -0.322,16.071 -7.919,4.529 h -0.32 L -15.895,15.982 -16.157,0 h -2.366 l 0.816,21.767 0.438,0.06 L -7.977,7.685 1.081,21.827 1.547,21.767 2.366,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,232.46773,275.90813)",
    clipPath: "url(#clipPath12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 181.418,97.951 h 2.338 V 76.534 h -2.338 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,377.95333)",
    clipPath: "url(#clipPath14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 0,0 c -6.604,0 -11.366,4.616 -11.366,11.043 0,6.312 4.879,11.073 11.366,11.073 2.833,0 5.375,-0.992 7.069,-2.044 L 6.106,18.085 c -1.812,1.053 -4.266,1.841 -6.312,1.841 -5.404,0 -8.619,-3.827 -8.619,-8.883 0,-5.054 3.419,-8.853 8.825,-8.853 2.044,0 4.498,0.789 6.311,1.841 L 7.069,2.044 C 5.375,0.992 2.833,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,265.85173,276.37427)",
    clipPath: "url(#clipPath16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 0,0 -3.944,-9.203 h 7.888 z m 7.334,-17.092 -2.541,5.933 h -9.584 l -2.543,-5.933 h -2.425 l 9.613,21.797 h 0.38 l 9.612,-21.797 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,289.80747,253.11907)",
    clipPath: "url(#clipPath18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 0,0 c -1.295,0 -2.709,-0.089 -3.474,-0.236 v -17.396 c 0.912,-0.176 2.062,-0.236 3.768,-0.236 6.358,0 9.272,4.004 9.272,9.125 C 9.566,-3.739 6.271,0 0,0 m 0,-19.899 c -2.179,0 -4.151,0.177 -5.827,0.354 V 1.647 c 1.647,0.207 3.443,0.354 5.621,0.354 8.095,0 12.334,-5.21 12.334,-10.744 0,-5.799 -4.034,-11.156 -12.128,-11.156",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,80.7528,287.41467)",
    clipPath: "url(#clipPath20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 0,0 -3.974,-9.272 h 7.948 z m 7.389,-17.219 -2.56,5.976 h -9.655 l -2.562,-5.976 H -9.83 L -0.146,4.739 H 0.236 L 9.92,-17.219 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,110.4208,290.75187)",
    clipPath: "url(#clipPath22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M 0,0 -0.324,16.189 -7.978,4.562 H -8.3 L -16.013,16.102 -16.277,0 h -2.384 l 0.823,21.929 0.442,0.059 L -8.036,7.741 1.089,21.988 1.56,21.929 2.384,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,160.30227,313.71027)",
    clipPath: "url(#clipPath24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 0,0 -3.974,-9.272 h 7.947 z m 7.388,-17.219 -2.56,5.976 h -9.655 l -2.562,-5.976 h -2.442 l 9.684,21.958 h 0.382 l 9.684,-21.958 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,179.53147,290.75187)",
    clipPath: "url(#clipPath26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 0,0 c -1.295,0 -2.709,-0.089 -3.474,-0.236 v -17.396 c 0.912,-0.176 2.062,-0.236 3.769,-0.236 6.357,0 9.271,4.004 9.271,9.125 C 9.566,-3.739 6.271,0 0,0 m 0,-19.899 c -2.179,0 -4.15,0.177 -5.829,0.354 V 1.647 c 1.649,0.207 3.445,0.354 5.623,0.354 8.095,0 12.334,-5.21 12.334,-10.744 0,-5.799 -4.034,-11.156 -12.128,-11.156",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,203.86347,287.41467)",
    clipPath: "url(#clipPath28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 0,0 v 21.575 h 12.626 v -2.12 H 2.354 v -7.446 h 9.242 V 9.891 H 2.354 V 2.119 H 12.626 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,225.33227,313.71027)",
    clipPath: "url(#clipPath30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 186.039,69.758 h 2.355 V 48.183 h -2.355 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,377.95333)",
    clipPath: "url(#clipPath32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 0,0 c -1.002,0 -2.209,-0.059 -2.974,-0.234 v -8.772 c 0.706,-0.089 1.796,-0.147 2.62,-0.147 4.033,0 5.769,1.854 5.769,4.651 C 5.415,-1.971 3.531,0 0,0 m 6.651,-19.603 -5.74,8.507 c -0.472,-0.029 -0.941,-0.059 -1.441,-0.059 -0.706,0 -1.738,0.03 -2.444,0.059 v -8.507 h -2.355 v 21.37 c 1.59,0.206 3.179,0.353 4.975,0.353 5.564,0 8.3,-2.767 8.3,-6.474 0,-3.003 -1.677,-5.271 -4.709,-6.241 l 6.269,-9.008 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,264.81147,287.57347)",
    clipPath: "url(#clipPath34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 0,0 -3.974,-9.272 h 7.948 z m 7.388,-17.219 -2.56,5.976 h -9.655 l -2.562,-5.976 h -2.442 l 9.684,21.958 h 0.382 l 9.684,-21.958 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,291.1448,290.75187)",
    clipPath: "url(#clipPath36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAm2);
export default __webpack_public_path__ + "static/media/LogoAM2.6132b69f76a705e793e005bc51cae039.svg";
export { ForwardRef as ReactComponent };